import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import documentManagement from "../../../assets/images/plmimplementationimage/document-management.jpg";

const DocumentOverview = () => {
  const imgRef = useRef(null);

  // --- PARALLAX IMAGE ---
  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY * 0.12;
      if (imgRef.current) imgRef.current.style.transform = `translateY(${y}px)`;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Wrapper>
      <Particles />
      <Grid />

      <Container className="container">

        {/* LEFT TEXT */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <SecTitle>
            <Title>About Us</Title>
            <Heading>Overview</Heading>
          </SecTitle>

          <Text>
            NexTech helps your business to efficiently implement a Teamcenter document 
            management solution that establishes a single Integrated Intellectual 
            Property (IP) backbone for your organization that incorporates authors 
            and documents in the product development lifecycle…
          </Text>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <ImageCard ref={imgRef}>
            <img src={documentManagement} alt="Document Management" />
          </ImageCard>
        </motion.div>

      </Container>
    </Wrapper>
  );
};

export default DocumentOverview;


/* -------------------- STYLED COMPONENTS -------------------- */

const Wrapper = styled.section`
  position: relative;
  padding: 120px 0;
  overflow: hidden;
  background: #f7fbff;
  font-family: "Poppins", system-ui;
`;

/* ⭐ PARTICLE BACKGROUND */
const Particles = styled.div`
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(2px 2px at 20px 40px, #00eaff 80%, transparent 0),
    radial-gradient(2px 2px at 120px 220px, #00eaff 80%, transparent 0),
    radial-gradient(2px 2px at 300px 80px, #00eaff 80%, transparent 0),
    radial-gradient(2px 2px at 500px 300px, #00eaff 80%, transparent 0);
  background-size: 600px 600px;
  animation: moveParticles 18s linear infinite;
  opacity: 0.35;
  z-index: 1;

  @keyframes moveParticles {
    from { transform: translateY(0); }
    to { transform: translateY(-250px); }
  }
`;

/* ⭐ TECH GRID BACKGROUND */
const Grid = styled.div`
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0, 180, 255, 0.12) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 180, 255, 0.12) 1px, transparent 1px);
  background-size: 55px 55px;
  animation: gridFlow 13s linear infinite;
  opacity: 0.35;
  z-index: 1;

  @keyframes gridFlow {
    from { transform: translateY(0); }
    to { transform: translateY(-55px); }
  }
`;

const Container = styled.div`
  display: flex;
  gap: 60px;
  z-index: 5;
  position: relative;

  @media (max-width: 900px) {
    flex-direction: column;
    text-align: center;
  }
`;

const SecTitle = styled.div`
  margin-bottom: 40px;
`;

const Title = styled.div`
  color: #d7a449;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 10px;
`;

const Heading = styled.h2`
  font-size: 2.6rem;
  font-weight: 700;
  color: #06334b;
`;

const Text = styled.p`
  color: #666;
  line-height: 1.8;
  margin-top: 20px;
  max-width: 600px;
`;

/* ⭐ IMAGE WITH NEON GLOW + PARALLAX */
const ImageCard = styled.div`
  width: 480px;
  border-radius: 14px;
  overflow: hidden;
  border: 2px solid rgba(0, 225, 255, 0.5);
  box-shadow: 0 0 28px rgba(0, 225, 255, 0.6);
  transition: 0.3s;

  img { width: 100%; }

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 0 38px rgba(0, 225, 255, 0.8);
  }

  @media (max-width: 900px) {
    margin: auto;
    width: 90%;
  }
`;
